// src/admin/components/ImageUploader.jsx

import { useTheme } from "../../context/ThemeContext";

export default function ImageUploader({
    title = "Image",
    description = "",
    preview,
    onChange,
}){

  const { isDark } = useTheme();

  return (
    <div
      className={`
        border-2
        border-dashed
        rounded-2xl
        p-6
        text-center
        ${
          isDark
            ? "border-white/10"
            : "border-gray-300"
        }
      `}
    >
      {preview ? (
        <img
          src={preview}
          alt="preview"
          className="
            w-full
            rounded-xl
            object-cover
          "
        />
      ) : (
        <p>
          Upload Featured Image
        </p>
      )}

      <input
        type="file"
        accept="image/*"
        onChange={onChange}
        className="mt-4"
      />
    </div>
  );
}